<template>
  <div class="certificate-con">
    <!-- 报告列表 -->
    <div class="search-list" v-loading="loading">
      <ul class="search-list-con"
          v-if="dataList.length">
        <li v-for="data in dataList"
            :key="data.id">
          <div class="list-img">
            <img :src="data.url || require('@/assets/img/zwtp.png')" />
            <div class="status">
              <span v-if="data.status === 1"><img src="@/assets/img/live/live.png"
                     width="16px"
                     height="16px" />正在直播...</span>
              <span v-else-if="data.status === 0"><img src="@/assets/img/live/time.png"
                     width="16px"
                     height="16px" />课程即将开始...</span>
              <span v-else-if="data.status === 2"><img src="@/assets/img/live/end.png"
                     width="16px"
                     height="16px" />课程已结束</span>
            </div>
          </div>
          <div class="list-con">
            <p>
              课程名称：
              <span>{{data.title}}</span>
            </p>
            <p style="margin:10px 0">
              课程类型：
              <span>{{data.type=== 1 ? '直播' : '预告'}}</span>
            </p>
            <p style="margin:10px 0">
              直播时间：
              <span>{{data.liveTime}}</span>
            </p>
            <p>
              培训讲师：
              <span>{{data.teacherName}}</span>
            </p>
            <p style="margin:10px 0">
              课程简介：
              <span>{{data.marks}}</span>
            </p>
          </div>
          <div class="list-btn cf jc">
            <!-- <div class="jionButton endclass" v-if="data.status === 2">课程已结束</div>
            <div class="jionButton" v-else-if="data.status === 1" @click="handlejoinClick(data)">进入直播</div>
            <div class="jionButton endclass" v-else-if="data.registrStatus ==1">进入直播</div>
            <div class="apply-text" v-else-if="data.registrStatus ==2"><img src="/static/img/live/apply.png" width="16px" height="16px"/>已报名,未审核</div>
            <div class="jionButton" v-else-if="data.registrStatus ==3" @click="handleRegister(data)">报名</div> -->
            <div class="jionButton endclass" v-if="data.studentStatus == 3">已取消</div>
            <div class="apply-text"
                 v-else-if="data.type ==2 && data.status != 2 && data.registrStatus == 1">报名成功</div>
            <div class="apply-text"
                 v-else-if="data.type ==2 && data.status == 1 && data.registrStatus == 3">进行中</div>
            <div class="jionButton endclass"
                 v-else-if="data.status === 2">课程已结束</div>
            <div class="apply-text"
                 v-else-if="data.registrStatus ==2 || data.registrStatus == 4"><img src="@/assets/img/live/apply.png"
                   width="16px"
                   height="16px" />已报名,未审核</div>
            <div class="jionButton"
                 v-else-if="data.registrStatus ==3"
                 @click="handleRegister(data)">报名</div>
            <div class="jionButton"
                 :class="{'endclass': data.status !== 1}"
                 v-else-if="data.registrStatus ==1"
                 @click="handlejoinClick(data)">进入直播</div>
            <div class="jionButton"
                 v-if="data.studentStatus != 3 && data.type ==2 && data.status == 1 && data.registrStatus == 3"
                 @click="handleRegister(data)">报名</div>
            <!-- 专题支付 -->
            <div class="rf" v-else-if="data.studentStatus != 3 && data.type ==2 && [2,4].includes(Number(data.registrStatus))&&(data.activityPrice  > 0) && !data.paymentTime">
              <div class="self-button primary-but" @click="payHandle(data)">去支付</div>
              <div class="self-button ordinary-but" @click="canclehandle(data)">取消</div>
              <div class="self-button danger-but" @click="deleteHandle(data)">删除订单</div>
            </div>
          </div>
        </li>
      </ul>
      <div v-else
           style="text-align:center">
        <img src="@/assets/img/good/noGood.png"
             alt="暂无数据" />
      </div>
    </div>
    <!-- 分页 -->
    <el-pagination background
                   style="margin-top:10px;text-align: center;"
                   layout="prev, pager, next, total, jumper, slot"
                   prev-text="上一页"
                   next-text="下一页"
                   @current-change="getList"
                   :current-page="currentPage"
                   :page-size="pageSize"
                   :pager-count="5"
                   :total="total"></el-pagination>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      loading: false,
      dataForm: {
        name: '',
        phone: ''
      },
      dataList: [],
      currentPage: 1,
      pageSize: 10,
      total: 1,
      dataListLoading: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 在线报名
    handleRegister (data) {
      if (getAccessToken()) {
        this.$router.push({
          name: 'onLineSignUp',
          query: {
            id: data.id,
            title: data.title,
            type: data.type,
            qualification: data.qualification,
            activityPrice: data.activityPrice,
            liveTime: data.liveTime
          }
        })
      } else {
        this.$router.push('/login')
      }
    },
    // 加入直播
    handlejoinClick (row) {
      if (getAccessToken()) {
        this.$router.push({
          name: 'studentLive',
          query: {
            id: row.id
          }
        })
      } else {
        this.$router.push('/login')
      }
    },
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'livenoticeList') {
        this.$router.push({ name: 'livenoticeList' })
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.getList(1)
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    getList (page = this.currentPage) {
      this.currentPage = page
      this.$http
        .post(
          `/front/train/neteaseLiveTrain/studentLiveClasslist`,
          // `${window.SITE_CONFIG["trainURL"]}/liveManagement/trainlivenotice/list`,
          {
            page: page,
            limit: this.pageSize,
            title: null,
            marks: null
            // startTime: null,
            // endTime: null
          }
        )
        .then(data => {
          // console.log(data);
          if (data.data.code === 0) {
            this.total = data.data.data.count
            this.dataList = data.data.data.data
          } else {
            this.total = 0
            this.dataList = []
          }
        })
        .catch(() => {
          this.total = 0
          this.dataList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 支付结算
    payHandle (row) {
      this.$router.replace({ name: 'settlement', query: { goodsId: row.id, type: 6 } })
    },
    // 取消报名
    canclehandle (data) {
      if (this.loading) {
        return false
      }
      this.$confirm(`确定取消该报名操作吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$http
            .post(
              `/front/train/neteaseLiveTrain/cancelSpecialTraining/${data.studentId}`
            )
            .then((data) => {
              // console.log(data);
              if (data.data.code === 0) {
                this.getList()
              }
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {})
    },
    // 删除报名
    deleteHandle (data) {
      // TODO
      if (this.loading) {
        return false
      }
      this.$confirm(`确定删除该报名操作吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$http
            .post(
              `/front/train/neteaseLiveTrain/deleteSpecialTraining/${data.studentId}`
            )
            .then((data) => {
              if (data.data.code === 0) {
                this.getList()
              }
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped lang="scss">
.self-button{
  height: 30px;
  line-height: 30px;
  padding: 0 6px;
  cursor: pointer;
  margin-right: 10px;
}
.primary-but{
  background: #1e64a9;
  color: #fff;
}
.ordinary-but{
  color: #1e64a9;
  background: #fff;
  border: 1px solid #F2F6FC;
}
.danger-but{
  color: #F81B1B ;
  background: #fff;
  border: 1px solid #F81B1B ;
}
.jionButton {
  position: relative;
  // top: 45%;
  width: 120px;
  height: 30px;
  line-height: 30px;
  background: #1e64a9;
  color: #fff;
  text-align: center;
  // margin: 0 auto;
  // border-radius: 10px;
  cursor: pointer;
}
.endclass {
  background: #999999;
  cursor: no-drop;
}
.apply-text {
  position: relative;
  // top: 45%;
  // margin: 0 auto;
  line-height: 26px;
  // width: 120px;
  // font-size: 16px;
  color: #1d65a8;
  // text-align: center;
}
.certificate-con {
  width: 100%;
  min-height: 400px;
  background: #fff;
}
.search {
  padding: 20px 30px;
  height: 70px;
  text-align: center;
}
.search-list {
  min-height: 400px;
  padding: 20px 20px;
}
.search-list-con {
  margin: 0 auto;
  min-height: 400px;
}
.search-list-con li {
  width: 100%;
  // height: 170px;
  padding: 15px 20px;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
}
.list-img {
  flex-shrink: 0;
  width: 200px;
  // height: 130px;
}
.list-img img {
  width: 180px;
  height: 100px;
}
.list-img .status {
  text-align: center;
  height: 20px;
  margin: 20px auto 0;
  color: #1d65a8;
}
.list-img .status img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
.list-con {
  // width: 500px;
  // height: 140px;
  // float: left;
  // padding: 10px;
  padding-left: 30px;
  color: #333;
  flex-grow: 1;
}
.list-btn {
  margin-left: 20px;
  width: 200px;
  flex-shrink: 0;
  position: relative;
  // height: 130px;
  // float: right;
  // text-align: right;
  // padding-top: 80px;
}
.list-con h3 {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
</style>
